module.exports = __webpack_public_path__ + "img/book.8f2caae1.svg";